import { render, staticRenderFns } from "./PeriodVacationDaysList.vue?vue&type=template&id=2e0a0b7c&"
import script from "./PeriodVacationDaysList.vue?vue&type=script&lang=js&"
export * from "./PeriodVacationDaysList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports